export default "__VITE_ASSET__Dt2Sego5__"